<template>
  <div class="register-step">
    <div class="header">
      <span class="header-text">{{ t('Step {0}', [step]) }}</span>
    </div>
    <div class="step-indicator">
      <div
        v-for="i in count"
        :key="i"
        class="step-indicator-shard"
        :class="{ empty: step < i }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables';

const { t } = useI18n();

withDefaults(
  defineProps<{
    step?: number;
    count?: number;
  }>(),
  {
    step: 1,
    count: 1,
  },
);
</script>

<style lang="scss" scoped>
.register-step {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 24px;

  .header {
    margin-bottom: 10px;
  }

  .header-text {
    font-size: 13px;
    line-height: 1.69;
    color: var(--color-graphite);
  }

  .step-indicator {
    display: flex;
    justify-content: center;
  }

  .step-indicator-shard {
    width: 32px;
    height: 4px;
    border-radius: 2px;
    background-color: var(--color-blue);

    & + .step-indicator-shard {
      margin-left: 4px;
    }

    &.empty {
      background-color: var(--color-gray10);
    }
  }
}
</style>
